export enum EnvironmentName {
    Production = 'Production',
    UAT = 'UAT',
    Test = 'Test',
    Development = 'Development',
    DevOps = 'DevOps'
}
